import React, { useEffect, useState } from 'react';
import ReportList from './components/ReportList/ReportList';
import Title from '../../../components/Title/Title';
import style from './dayReport.less';
import { parse } from 'qs';
import { Toast } from 'antd-mobile';
import { BaseUrl } from '../../../service';
import SkeletonScreen from '../../../components/SkeletonScreen/SkeletonScreen';

function DayReport() {
  const [isSkeletonScreen, setIsSkeleton] = useState(true);
  const [reportData, setReportData] = useState({});

  const getReportData = () => {
    const { pathname, search = '?' } = window.location;
    const query = parse(search.substring(1));

    fetch(
      BaseUrl +
      `/api/analyzer/report/daily.v1?queries=${query.queries}`,
      {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
      },
    )
    .then(async (response) => {
      if (response.ok) {
        return response;
      }
      throw new Error('网络响应异常.');
    })
    .then(async (res) => {
      const result = await res.json();

      const dateTime = result?.data?.date;
      const info = result?.data?.info;
      const overview = result?.data?.overview;
      const validAccounts = result?.data?.accounts.filter(
        (item) => item.served_users > 0,
      );
      const invalidAccounts = result?.data?.accounts.filter(
        (item) => item.served_users <= 0,
      );

      setReportData({
        info: info || {},
        dateTime: dateTime,
        overview: overview || {},
        validAccounts: validAccounts || [],
        invalidAccounts: invalidAccounts || [],
      });
      setIsSkeleton(false);
    })
    .catch((err) => {
      Toast.fail('网络连接失败 !!!', 1);
    });
  };

  useEffect(() => {
    getReportData();
  }, []);


  return (
    <div>
      {isSkeletonScreen ? (
        <SkeletonScreen />
      ) : (
        <div className={style.reportContainer}>
          <div className={style.content}>
            <div className={style.title}>
              {reportData?.info?.organization_name}
              <span>{reportData?.dateTime}</span>
            </div>
            <div className={style.grid}>
              <div className={style.gridWarp}>
                <div className={style.gridItem}>
                  <div>{reportData?.overview?.served_users}</div>
                  <div>咨询总人数/人</div>
                </div>
                <div className={style.gridItem}>
                  <div>{reportData?.overview?.added_users}</div>
                  <div>新增客户/人</div>
                </div>
                <div className={style.gridItem}>
                  <div>
                    {Math.round(reportData?.overview?.rate24 * 100 || 0)}%
                  </div>
                  <div>成交率</div>
                </div>
              </div>
              <div className={style.gridWarpTwoColumns}>
                <div className={style.gridItem}>
                  <div>{reportData?.overview?.invoices2}</div>
                  <div>
                    新增<span className={style.consult}>咨询单</span>
                  </div>
                </div>
                <div className={style.gridItem}>
                  <div>{reportData?.overview?.invoices3}</div>
                  <div>
                    新增<span className={style.offer}>报价单</span>
                  </div>
                </div>
                <div className={style.gridItem}>
                  <div>{reportData?.overview?.invoices4}</div>
                  <div>
                    新增<span className={style.settlement}>结算单</span>
                  </div>
                </div>
              </div>
            </div>
            <Title isBolder showDeco>
              人力效能
              <div className={style.titleLabel}>
                {reportData?.validAccounts?.length}
              </div>
            </Title>
            <div className={style.listWarp}>
              {reportData?.validAccounts?.map((item) => {
                return <ReportList data={item} />;
              })}
            </div>
            <Title isBolder showDeco>
              暂无数据
              <div className={style.titleLabel}>
                {reportData?.invalidAccounts?.length}
              </div>
            </Title>
            <div className={style.recordWrap}>
              {reportData?.invalidAccounts?.map((value) => {
                return (
                  <div
                    className={style.recordItem}

                  >
                    <div className={style.left}>
                      <label>姓名：</label>
                      <span>{value.name}</span>
                    </div>
                    <div className={style.right}>
                      <label>登录地址：</label>
                      <span>
                        {value?.locations?.length > 0
                          ? value?.locations[0].address
                          : '-'}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DayReport;
